"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.default = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _Input = require("./Input.constants");
require("./Input.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Input = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2.default)(Input, _PureComponent);
  function Input(props) {
    var _this;
    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      value: '',
      icon: _Input.iconDefault,
      isApplyDisabled: false
    };
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.onKeyPress = _this.onKeyPress.bind((0, _assertThisInitialized2.default)(_this));
    _this.onKeyUp = _this.onKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSubmit = _this.onSubmit.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  var _proto = Input.prototype;
  _proto.onChange = function onChange(e) {
    var _this$props = this.props,
      onChange = _this$props.onChange,
      type = _this$props.type;
    this.setState({
      value: e.target.value
    });
    var value = e.target.value;
    this.setState({
      icon: value ? _Input.iconFocus : _Input.iconDefault,
      isApplyDisabled: !value
    });
    var currentValue = type === 'file' ? e.target.files : e.target.value;
    onChange(currentValue);
  };
  _proto.onBlur = function onBlur(e) {
    var onBlur = this.props.onBlur;
    onBlur(e);
  };
  _proto.onKeyPress = function onKeyPress(e) {
    var onKeyPress = this.props.onKeyPress;
    onKeyPress(e);
  };
  _proto.onKeyUp = function onKeyUp(e) {
    var onKeyUp = this.props.onKeyUp;
    onKeyUp(e);
  };
  _proto.onFocus = function onFocus(e) {
    var onFocus = this.props.onFocus;
    onFocus(e);
  };
  _proto.onSubmit = function onSubmit(e) {
    e.preventDefault();
    var onSubmit = this.props.onSubmit;
    var value = this.state.value;
    this.setState({
      icon: _Input.iconDefault,
      isApplyDisabled: true
    });
    onSubmit(value);
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      id = _this$props2.id,
      type = _this$props2.type,
      name = _this$props2.name,
      className = _this$props2.className,
      placeholder = _this$props2.placeholder,
      value = _this$props2.value,
      minLength = _this$props2.minLength,
      maxLength = _this$props2.maxLength,
      readOnly = _this$props2.readOnly,
      disabled = _this$props2.disabled,
      ariaLabel = _this$props2.ariaLabel,
      elementLocator = _this$props2.elementLocator,
      withSubmit = _this$props2.withSubmit,
      accept = _this$props2.accept,
      maxInputLength = _this$props2.maxInputLength,
      ariaSubmitLabel = _this$props2.ariaSubmitLabel,
      autoComplete = _this$props2.autoComplete;
    var inputElement = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("label", {
      htmlFor: id,
      className: "visually-hidden"
    }, name), _react.default.createElement("input", {
      id: id,
      type: type,
      name: name,
      className: "atom-input " + className,
      placeholder: placeholder,
      value: type !== 'file' ? value : undefined,
      readOnly: readOnly,
      disabled: disabled,
      "aria-label": ariaLabel,
      "data-locator": elementLocator || "input-" + type + "-" + name,
      min: minLength,
      max: maxLength,
      maxLength: maxInputLength,
      onChange: this.onChange,
      onBlur: this.onBlur,
      onKeyPress: this.onKeyPress,
      onKeyUp: this.onKeyUp,
      onFocus: this.onFocus,
      accept: accept,
      autoComplete: autoComplete || 'off'
    }));
    var icon = this.state.icon;
    return !withSubmit ? inputElement : _react.default.createElement("form", {
      onSubmit: this.onSubmit,
      className: "input-with-submit"
    }, inputElement, _react.default.createElement("button", {
      type: "submit",
      disabled: this.state.isApplyDisabled,
      "aria-label": ariaSubmitLabel,
      "data-locator": elementLocator + "-submit"
    }, _react.default.createElement(_reactSvg.ReactSVG, {
      src: icon,
      className: "submit-icon",
      "data-locator": elementLocator + "-submit-icon"
    })));
  };
  return Input;
}(_react.PureComponent);
Input.defaultProps = {
  id: '',
  name: '',
  type: 'text',
  className: '',
  placeholder: '',
  value: '',
  minLength: 0,
  maxLength: 999,
  ariaLabel: '',
  ariaSubmitLabel: 'submit',
  readOnly: false,
  disabled: false,
  elementLocator: '',
  withSubmit: false,
  onChange: function onChange() {
    /* default onChange handler */
  },
  onBlur: function onBlur() {
    /* default onBlur handler */
  },
  onKeyPress: function onKeyPress() {
    /* default onKeyPress handler */
  },
  onKeyUp: function onKeyUp() {
    /* default onKeyUp handler */
  },
  onFocus: function onFocus() {
    /* default onFocus handler */
  },
  onSubmit: function onSubmit() {
    /* default onSubmit handler */
  },
  accept: '',
  autoComplete: 'off'
};
var _default = Input;
exports.default = _default;
module.exports = exports["default"];